// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9159db5a","498":"2ae320fd","513":"e7e22859","787":"454a446d"}[chunkId] + ".chunk.js";
};